import { getCountry, getTimezone } from 'countries-and-timezones';

export const getSuggestedCountryCode = (
  timeZone?: string,
  locale?: string
): string | undefined => {
  const timeZoneCountries = timeZone
    ? getTimezone(timeZone)?.countries
    : undefined;
  const timeZoneCountry =
    timeZoneCountries?.length === 1 ? timeZoneCountries[0] : undefined;
  const localeCountry = locale
    ?.replace(/_/g, '-')
    .split('-')
    .find((part, index) => index > 0 && /^[A-Z]{2}$/i.test(part))
    ?.toUpperCase();
  const countryCode =
    timeZoneCountry ??
    (timeZoneCountries && timeZoneCountries.length > 1
      ? timeZoneCountries.find((country) => country === localeCountry)
      : localeCountry);

  return countryCode && getCountry(countryCode) ? countryCode : undefined;
};
